import { BlobProvider, PDFViewer } from '@react-pdf/renderer'
import SubscriptionPdfRenderer from 'components/SubscriptionPdfRenderer'
import { X } from 'lucide-react'
import React, { useEffect, useState } from 'react'

interface SubscriptionAgreementModalProps {
  isVisible: boolean
  setVisible: () => void
  getValues: any
}

export const removeOnly = (input: string): string => {
  return input.replace(/\bOnly\b/gi, '')
}

const SubscriptionAgreementModal = ({ isVisible, setVisible, getValues }: SubscriptionAgreementModalProps) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkDevice()
    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [])

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isVisible])

  if (!isVisible) return null

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" onClick={setVisible} />

      {/* Modal Container */}
      <div className="fixed inset-0 rounded-none bg-white shadow-xl md:absolute md:inset-auto md:left-1/2 md:top-1/2 md:h-[90vh] md:w-[90%] md:max-w-5xl md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-xl">
        {/* Header */}
        <div className="sticky top-0 z-10 flex justify-end border-b bg-white p-4">
          <button
            onClick={setVisible}
            className="rounded-full p-2 transition-colors hover:bg-gray-100"
            aria-label="Close"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content Area */}
        <div className="h-[calc(100%-64px)] overflow-hidden">
          {isMobile ? (
            // Mobile: BlobProvider for better mobile rendering
            <BlobProvider document={<SubscriptionPdfRenderer getValues={getValues} />}>
              {({ url, loading }) => {
                if (loading || !url) {
                  return (
                    <div className="flex h-full items-center justify-center">
                      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
                    </div>
                  )
                }
                return <iframe src={url} className="h-full w-full" title="Subscription Agreement" />
              }}
            </BlobProvider>
          ) : (
            // Desktop: PDFViewer
            <PDFViewer showToolbar={true} className="h-full w-full border-none">
              <SubscriptionPdfRenderer getValues={getValues} />
            </PDFViewer>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubscriptionAgreementModal
